var map = {
	"./ISO.webp": 7800,
	"./Registration.webp": 1002,
	"./anz_certificate.webp": 1902,
	"./icsi_certificate.webp": 4911,
	"./redis_certificate.webp": 9206,
	"./skillfront_certificate.webp": 9207
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6346;